import React, { useMemo } from 'react';
import { IMetricsSteamCard } from '../../type';
import { reviewsFormat } from '@op/utils/value';
import useLanguage from '@op/hooks/useLanguage';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import VoteBar from '@op/components/Snippets/VoteBar';
import ProgressContext from '@/pages/opinion/components/ProgressContext';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';
import { DBO_TM, DBO_V } from '@op/utils/format';
import _ from 'lodash-es';
import CardCommon from '@op/components/CardCommon';

export default function SteamMetricsCard(props: IMetricsSteamCard) {
  const { classNames, data, tabItem, filter, loading, isToday, wholeGameInfo } = props;
  const { formatMessage } = useLanguage();

  const {
    oldTime,
    newTime,
    title,
    formatValue,
    icon,
    tips,
    tagText,
    subTitle,
    total,
    positive,
    negative,
    valueKey,
    noSubtitle
  } = useMemo(() => {
    const { formatValue = reviewsFormat, valueKey, noSubtitle, keys, title, otherTitle } = tabItem;
    const value = data?.[valueKey] || 0;
    const { newTime, oldTime } = data;
    const subTitle = (formatMessage: any) => {
      return noSubtitle ? null : (
        <span className="dbo-steam-metrics-text-date">
          {formatMessage({ id: `From the game's release to {date}` }, { date: DBO_TM.sFormat(filter.start_time, 'MM-DD') })}
        </span>
      );
    };

    const realData: { [key in keyof typeof keys]: any } = {
      total: {},
      positive: {},
      negative: {},
    };
    _.forOwn(keys, (value: string, key: 'total') => {
      realData[key] = data?.[value] || {};
    });

    return {
      oldTime,
      newTime,
      formatValue,
      value,
      subTitle,
      ...tabItem,
      ...realData,
      title: !isToday ? otherTitle || title : title,
    };
  }, [data, isToday]);

  const formatDate = DBO_TM.formatFunc(filter?.date_type);

  return (
    <CardCommon
      contentCard
      className={classnames(
        classNames,
        'dbo-realtime-opinion-steam-metrics-card',
      )}
      loading={loading}
      loadingHeight={182}
    >
      <div className="dbo-steam-metrics-hd">
        {tagText && (
          <span className="dbo-steam-metrics-from-tag">
            {formatMessage(tagText)}
          </span>
        )}
        <div className="dbo-steam-metrics-title">
          <SvgIcon className={`dbo-steam-metrics-svg-icon dbo-steam-metrics-svg-icon-${icon}`} type={icon}></SvgIcon>
          <p className="dbo-steam-metrics-title-text">
            <span>{formatMessage({ id: title })}</span>
          </p>
        </div>
        <div className="dbo-steam-metrics-tips">
          {formatMessage({ id: tips })}
        </div>
        {
          !noSubtitle && (
            <div className="dbo-steam-metrics-from">
              {subTitle(formatMessage)}
            </div>
          )
        }
      </div>
      <div className="dbo-steam-metrics-content">
        <div className="dbo-steam-metrics-content-wrap">
          <div className="dbo-steam-metrics-nums">
            <div className="dbo-steam-metrics-value">
              {valueKey === "hourly" && total?.review > 0 && '+'}
              {formatValue(total?.review || 0)}
            </div>
            {
              valueKey === 'hourly' && (
                <RingRatioBubble
                  otherInfo={
                    <div className="item-title">{formatMessage({ id: title })}</div>
                  }
                  newTime={newTime}
                  oldTime={oldTime}
                  oldValue={total?.review_old || 0}
                  formateDate={formatDate}
                  newValue={total?.review || 0}
                  placement="top-start"
                  formateValue={formatValue}
                >
                  <span style={{ minWidth: 100 }}>
                    <span className="context-text">
                      {isToday ? formatMessage({ id: 'HoH' }) : formatMessage({ id: 'DoD' })}
                    </span>
                    <PercentageItem
                      percentage={total?.review_qoq || 0}
                    ></PercentageItem>
                  </span>
                </RingRatioBubble>
              )
            }
          </div>
          <VoteBar
            upVotes={positive?.review || 0}
            downVotes={negative?.review || 0}
            totalReview={total?.review || 0}
          ></VoteBar>
        </div>

        <div className="dbo-steam-metrics-progress">
          <p className="dbo-steam-metrics-progress-tips">
            {formatMessage({ id: 'Positive%-3' })}
          </p>
          {/* {
            valueKey === 'hourly' && (
              <p className="dbo-steam-metrics-progress-change">
                <RingRatioBubble
                  otherInfo={
                    <div className="item-title">
                      {formatMessage({ id: 'Positive%' })}
                    </div>
                  }
                  newTime={newTime}
                  oldTime={oldTime}
                  oldValue={total?.score_old || 0}
                  formateDate={formatDate}
                  newValue={total?.score || 0}
                  placement="top-start"
                  formateValue={(val) => DBO_V.percentageFormat(val * 100, '-', 0)}
                >
                  <PercentageItem percentage={total?.score_qoq || 0}></PercentageItem>
                </RingRatioBubble>
              </p>
            )
          } */}
          {/* <div className={`dbo-steam-metrics-progress-bar ${valueKey === 'hourly' ? '--show-change' : ''}`}> */}
          <div className={`dbo-steam-metrics-progress-bar`}>
            <ProgressContext
              percent={reviewsFormat((total?.score || 0) * 100, 2)}
              circle
              sentiment
              strokeWidth={20}
              sizeWidth={280}
              text={
                <div className="dbo-steam-metrics-progress-text">
                  {reviewsFormat((total?.score || 0) * 100, 2)}
                  {
                    total?.score ? (
                      <span className="percent-symbol">%</span>
                    ) : null
                  }
                </div>
              }
              strokeColor={total?.score ? '#29B569' : 'none'}
            />
          </div>
        </div>
      </div>
    </CardCommon >
  );
}
